import { ReferenceValueAndFormForCal } from "@admincommon/models/references/reference-calculated-values-table.model";
import { FormGroup, FormControl, Validators } from "@angular/forms";
import { ReferenceValueDto } from "@sharedcommon/rest/data.restservice";
import { Constants } from "@sharedcommon/util/constants.util";

export class ReferenceCalculatedValuesTableService {

    /**
     * Get array of ReferenceValueAndFormForCal from array of ReferenceValueDto
     * @param referenceValueDtos the array with what we will create ReferenceValueAndFormForCal
     * @returns the corresponding array of ReferenceValueAndFormForCal
     */
    static getListRefValAndFormFromDto(referenceValueDtos: ReferenceValueDto[]): ReferenceValueAndFormForCal[] {
        const allRefValues: ReferenceValueAndFormForCal[] = [] ;
        referenceValueDtos.forEach((refDto) => {
            allRefValues.push(this.createReferenceValueAndFormFromDto(refDto)) ;
        }) ;
        return allRefValues ;
    }

    /**
     * Create a ReferenceValueAndFormForCal object from referenceDto
     * @param referenceValDto the ReferenceValueDto from what the object must come from
     * @return ReferenceValueAndFormForCal connected to referenceValDto
     */
    static createReferenceValueAndFormFromDto(referenceValDto: ReferenceValueDto): ReferenceValueAndFormForCal {
        const newRefValAndForm = new ReferenceValueAndFormForCal() ;
        newRefValAndForm.form = new FormGroup({
            'maxVal': new FormControl(null, [ Validators.pattern(Constants.REGEX_DECIMAL) ]),
            'minVal': new FormControl(null, [ Validators.pattern(Constants.REGEX_DECIMAL) ]),
            'limitable': new FormControl(false),
            'cappable': new FormControl(false),
            'ceilVal': new FormControl(null, [ Validators.pattern(Constants.REGEX_DECIMAL) ]),
            'floorVal': new FormControl(null, [ Validators.pattern(Constants.REGEX_DECIMAL) ])
        });
        newRefValAndForm.referenceValue = referenceValDto ;
        newRefValAndForm.form.patchValue(referenceValDto) ;
        return newRefValAndForm ;
    }

    /**
     * Get the maxVal form control form the refValAndForm
     * @param refValAndForm the object from which you want the form control
     * @returns the form control of maxVal
     */
    static getMaxFormFromRefValAndForm(refValAndForm: ReferenceValueAndFormForCal): FormControl {
        return refValAndForm.form.get('maxVal') as FormControl ;
    }

    /**
     * Get the minVal form control form the refValAndForm
     * @param refValAndForm the object from which you want the form control
     * @returns the form control of minVal
     */
    static getMinFormFromRefValAndForm(refValAndForm: ReferenceValueAndFormForCal): FormControl {
        return refValAndForm.form.get('minVal') as FormControl ;
    }

    /**
     * Get the limitable form control form the refValAndForm
     * @param refValAndForm the object from which you want the form control
     * @returns the form control of limitable
     */
     static getLimitableFormFromRefValAndForm(refValAndForm: ReferenceValueAndFormForCal): FormControl {
        return refValAndForm.form.get('limitable') as FormControl ;
    }

    /**
     * Get the floorVal form control form the refValAndForm
     * @param refValAndForm the object from which you want the form control
     * @returns the form control of floorVal
     */
    static getFloorFormFromRefValAndForm(refValAndForm: ReferenceValueAndFormForCal): FormControl {
        return refValAndForm.form.get('floorVal') as FormControl ;
    }

    /**
     * Get the cappable form control form the refValAndForm
     * @param refValAndForm the object from which you want the form control
     * @returns the form control of cappable
     */
    static getCappableFormFromRefValAndForm(refValAndForm: ReferenceValueAndFormForCal): FormControl {
        return refValAndForm.form.get('cappable') as FormControl ;
    }

    /**
     * Get the ceilVal form control form the refValAndForm
     * @param refValAndForm the object from which you want the form control
     * @returns the form control of ceilVal
     */
    static getCeilFormFromRefValAndForm(refValAndForm: ReferenceValueAndFormForCal): FormControl {
        return refValAndForm.form.get('ceilVal') as FormControl ;
    }
}